import { authHttp, http } from '../http'
import * as routes from '../../routes/settings.routes'
import { errorHandler } from '../../../util/error.service'

export async function getUsers() {
  try {
    const response = await authHttp().get(routes.urlUsers)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function GetUsersByTp(tp_id) {
  try {
    const response = await authHttp().get(routes.urlUsersByTp(tp_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function DeactivateMultipleUserByIds(tp_id, data) {
  try {
    const response = await authHttp().put(routes.urlUsersDeactivate(tp_id), data)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function CloneUserSettingsToAnotherUser(userBaseId, userTargetId, flags) {
  try {
    const response = await authHttp().put(routes.urlUsersClone(), {
      userBaseId,
      userTargetId,
      flags,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function userToggleActived(userId) {
  try {
    const response = await authHttp().put(routes.urlUserToggleActived(userId))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function userToggleActivedTpAdmin(userId, tpId, adminId) {
  try {
    const response = await authHttp().put(routes.urlUserToggleActivedTpAdmin(userId, tpId, adminId))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function editUser(userId, name) {
  try {
    const response = await authHttp().put(routes.urlEditUser(userId), { name })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function editUserTpAdmin(userId, tpId, adminId, name) {
  try {
    const response = await authHttp().put(routes.urlEditUserTpAdmin(userId, tpId, adminId), {
      name,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function registerUser({ name, email, password }) {
  try {
    const response = await authHttp().post(routes.urlRegisterUser, { name, email, password })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function loginUser({ email, password }) {
  try {
    const response = await http.post(routes.urlLoginUser, { email, password })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

function mfaErrorHandler(error) {
  if (error.response && error.response.data && error.response.data.reason) {
    return error.response.data
  }
  return { error: errorHandler(error) }
}
export async function verifyMfaCode({ challenge_id, code }) {
  try {
    const response = await http.post(routes.urlLoginMfaVerify, { challenge_id, code })
    return response.data
  } catch (error) {
    throw mfaErrorHandler(error)
  }
}
export async function resendMfaCode(challenge_id) {
  try {
    const response = await http.post(routes.urlLoginMfaResend, { challenge_id })
    return response.data
  } catch (error) {
    throw mfaErrorHandler(error)
  }
}
export async function getUsersTpsAssociaton(userId) {
  try {
    const response = await authHttp().get(routes.urlUserTpByUserId(userId))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function usersTpsAssociatonHandler({ user_id, tp_id, actived }) {
  try {
    const response = await authHttp().post(routes.urlUserTp, { user_id, tp_id, actived })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function getUsersGroupAssociaton(userId) {
  try {
    const response = await authHttp().get(routes.urlUserGroupByUserId(userId))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function usersGroupsAssociatonHandler({ user_id, group_id, actived }) {
  try {
    const response = await authHttp().post(routes.urlUserGroup, { user_id, group_id, actived })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function getUsersCompanyAssociaton(userId) {
  try {
    const response = await authHttp().get(routes.urlUserCompanyByUserId(userId))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function usersCompanysAssociatonHandler({ user_id, company_id, actived }) {
  try {
    const response = await authHttp().post(routes.urlUserCompany, { user_id, company_id, actived })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function getCentraisOperacionaisByUserId(userId) {
  try {
    const response = await authHttp().get(routes.urlGetCentralOperacoesByUserId(userId))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function userOperationCenterAssoctionHandler({
  user_id,
  operationcenter_id,
  actived,
}) {
  try {
    const response = await authHttp().post(routes.urlPostUserOperationCenter, {
      user_id,
      operationcenter_id,
      actived,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getActiveUsersByTp(tp_id) {
  try {
    const res = await authHttp().get(routes.urlUsersActiveByTp(tp_id))
    return res.data
  } catch (e) {
    throw errorHandler(e)
  }
}

export async function getUsersAllByTp(tpId, userId) {
  try {
    const res = await authHttp().get(routes.urlUsersAllByTp(tpId, userId))
    return res.data
  } catch (e) {
    throw errorHandler(e)
  }
}
